<template>
  <div>

    <div class="mb-4">
      <CheckboxGroup
          class="d-inline-block mb-0 align-middle cat-checkbox pointer"
          :readonly="!!object.custom_role_id"
          @input="allCheckedClicked"
          :value="allChecked"
          fid="all">
        <div class="form-label ml-10">{{ $t('all_rights') }}</div>
      </CheckboxGroup>
    </div>

    <div class="row mb-4" v-for="(arr, cat) in allFunctions"
           :key="`cat-${cat}`">
      <div class="col-12">
        <div class="font-weight-bold mb-4">
          <CheckboxGroup
              class="d-inline-block mb-0 align-middle cat-checkbox pointer"
              :readonly="!!object.custom_role_id"
              @input="catChecked(cat)"
              :value="catsChecked[cat]"
              :fid="`cat-${cat}`">
            <span class="font-weight-bold ml-10">{{ $t(cat) }}</span>
          </CheckboxGroup>
        </div>
      </div>
      <div class="col-md-4 col-12"
           v-for="f in arr"
           :key="`all_function_${f.id}`">
        <CheckboxGroup :label="f.title"
                       v-if="!object.custom_role_id"
                       :checkboxvalue="f.id"
                       :fid="`checkbox-f-${f.id}`"
                       v-model="object.userFunctions">
          <a v-if="f.note"
             :title="f.note"
             class="info ml-2"
             v-b-tooltip.hover>
            <InfoSvg class="info-svg"/>
          </a>
        </CheckboxGroup>
        <CheckboxGroup :label="f.title"
                       v-if="!!object.custom_role_id"
                       :readonly="true"
                       :checkboxvalue="f.id"
                       :fid="`checkbox-role-f-${f.id}`"
                       :value="roleFunctions">
        </CheckboxGroup>
      </div>
    </div>
  </div>
</template>

<script setup>

import InfoSvg from "@/assets/svg-vue/general/question.svg.vue"
import CheckboxGroup from "@/components/form/CheckboxGroup.vue"
import {computed} from "vue"

const { object, selectModels } = defineProps({
  object: {
    type: Object,
    required: true
  },
  selectModels: {
    type: Object,
    required: true
  }
})

const allFunctions = computed(() => {
  const functions = selectModels?.functions?.all_functions || {}
  const order = [
    'general',
    'calendar',
    'treatment',
    'staff',
    'communications',
    'finance',
    'reports',
    'egisz',
    'additional_modules'
  ]
  return Object.keys(functions).sort(function(a,b) {
    return order.indexOf(a) - order.indexOf(b)
  }).reduce((obj, key) => {
        obj[key] = functions[key]
        return obj
      }, {}
  )
})

const customRoles = computed(() => {
  return selectModels?.functions?.custom_roles || []
})

const roleFunctions = computed(() => {
  if(!object.custom_role_id) return []
  const role = customRoles.value.find(obj => Number(obj.id) === Number(object.custom_role_id))
  if(!role) return []
  return role.functions.map(obj => obj.id)
})

const catsChecked = computed(() => {
  const arr = {}
  for(const cat in allFunctions.value) {
    if(object.custom_role_id) {
      arr[cat] = allFunctions.value[cat].every(f => roleFunctions.value.includes(f.id))
    } else {
      arr[cat] = allFunctions.value[cat].every(f => object.userFunctions.includes(f.id))
    }
  }
  return arr
})

const catChecked = (cat) => {
  const funcs = allFunctions.value[cat] || []
  const selectedPreviously = catsChecked.value[cat]
  funcs.forEach((f) => {
    if(selectedPreviously) {
      const index = object.userFunctions.indexOf(f.id)
      if(index > -1) {
        object.userFunctions.splice(index, 1)
      }
    } else {
      if(!object.userFunctions.includes(f.id)) {
        object.userFunctions.push(f.id)
      }
    }
  })
}

const allChecked = computed(() => {
  return Object.values(catsChecked.value).every(cat => cat === true)
})

const allCheckedClicked = () => {
  if(allChecked.value) {
    object.userFunctions = []
  } else {
    object.userFunctions = Object.values((selectModels?.functions?.all_functions || {})).flat().map(obj => obj.id)
  }
}
</script>
